module.exports = __webpack_public_path__ + "img/107.8793cad2.jpg";